import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCalendarAlt, faEnvelope,  faUser, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

const PatientSidebar = () => {
  return (
    <nav className="mt-6">
      <Link to="/patient/dashboard" className="flex items-center px-4 py-2 hover:bg-orange-100">
        <FontAwesomeIcon icon={faHome} className="mr-3" />
        Bacheca
      </Link>
      <Link to="/patient/appoinments" className="flex items-center px-4 py-2 hover:bg-orange-100">
        <FontAwesomeIcon icon={faCalendarAlt} className="mr-3" />
        Appuntamenti
      </Link>
      <Link to="/patient/message" className="flex items-center px-4 py-2 hover:bg-orange-100">
        <FontAwesomeIcon icon={faEnvelope} className="mr-3" />
        Messaggi
      </Link>
      <Link to="/patient/profile" className="flex items-center px-4 py-2 hover:bg-orange-100">
        <FontAwesomeIcon icon={faUser} className="mr-3" />
        Profilo
      </Link>
      <Link to="/patient/login" className="flex items-center px-4 py-2 hover:bg-orange-100">
        <FontAwesomeIcon icon={faSignOutAlt} className="mr-3" />
        Logout
      </Link>

       {/* Pulsante di assistenza */}
       <div className="h-6"></div>
        <div className="p-4">
          <a
            href="mailto:help@personaltherapy.it"
            className="block bg-purple-600 text-white p-4 rounded-lg shadow-lg hover:bg-purple-700 transition-colors text-center"
          >
            <h3 className="font-bold">Hai bisogno di assistenza  ?</h3>
            <p className="text-sm">Scrivi subito a help@personaltherapy.it !</p>
          </a>
        </div>
        
    </nav>
  );
};

export default PatientSidebar;